export default __webpack_public_path__ + "static/media/2.f8c7a964.pdf";